import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppWidget = () => {
  const handleWhatsAppClick = () => {
    // Открываем WhatsApp с номером телефона
    const phoneNumber = '77073171819'; // Номер без +7
    const message = 'Здравствуйте! Хочу получить консультацию по матрасам.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="whatsapp-widget">
      <button 
        className="whatsapp-toggle-btn" 
        onClick={handleWhatsAppClick}
        title="Написать в WhatsApp"
      >
        <div className="whatsapp-icon">
          <FaWhatsapp />
        </div>
      </button>
    </div>
  );
};

export default WhatsAppWidget;
